export default "__VITE_ASSET__Bk$3oU8H__"